import * as React from "react";
import * as PopoverPrimitive from "@radix-ui/react-popover";

import { cn } from "../lib/utils";

const Popover = PopoverPrimitive.Root;

const PopoverTrigger = PopoverPrimitive.Trigger;

const PopoverAnchor = PopoverPrimitive.Anchor;

const PopoverContent = React.forwardRef<
  React.ElementRef<typeof PopoverPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof PopoverPrimitive.Content>
>(
  (
    { className = "tw-figr-p-m", align = "center", sideOffset = 4, ...props },
    ref
  ) => (
    <PopoverPrimitive.Portal>
      <PopoverPrimitive.Content
        ref={ref}
        align={align}
        sideOffset={sideOffset}
        className={cn(
          className,
          "tw-figr-z-50 tw-figr-w-72 tw-figr-rounded-m tw-figr-border tw-figr-border-neutral-200 tw-figr-bg-base-white tw-figr-font-secondary tw-figr-text-base-black tw-figr-text-desktop-caption-regular tw-figr-shadow-md tw-figr-outline-none data-[state=open]:tw-figr-animate-in data-[state=closed]:tw-figr-animate-out data-[state=closed]:tw-figr-fade-out-0 data-[state=open]:tw-figr-fade-in-0 data-[state=closed]:tw-figr-zoom-out-95 data-[state=open]:tw-figr-zoom-in-95 data-[side=bottom]:tw-figr-slide-in-from-top-2 data-[side=left]:tw-figr-slide-in-from-right-2 data-[side=right]:tw-figr-slide-in-from-left-2 data-[side=top]:tw-figr-slide-in-from-bottom-2"
        )}
        {...props}
      />
    </PopoverPrimitive.Portal>
  )
);
PopoverContent.displayName = PopoverPrimitive.Content.displayName;

export { Popover, PopoverTrigger, PopoverContent, PopoverAnchor };
